import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { orgTranslationRef } from '@backstage/plugin-org/alpha';

export const orgTranslation = TranslationBlueprint.make({
  name: 'org',
  params: {
    resource: createTranslationMessages({
      ref: orgTranslationRef,
      full: false,
      messages: {
        'groupProfileCard.groupNotFound': 'Groep niet gevonden',
        'groupProfileCard.editIconButtonTitle': 'Bewerk metadata',
        'groupProfileCard.refreshIconButtonTitle':
          'Plan verversing van entiteit',
        'groupProfileCard.refreshIconButtonAriaLabel': 'Ververs',
        'groupProfileCard.listItemTitle.entityRef': 'Entiteitsverwijzing',
        'groupProfileCard.listItemTitle.email': 'E-mail',
        'groupProfileCard.listItemTitle.parentGroup': 'Bovenliggende groep',
        'groupProfileCard.listItemTitle.childGroups': 'Onderliggende groepen',
        'membersListCard.cardLabel': 'Gebruikerspagina van {{memberName}}',
        'membersListCard.title': 'Leden van {{groupName}}',
        'membersListCard.noMembersDescription': 'Deze groep heeft geen leden.',
        'membersListCard.noSearchResult':
          'Geen leden gevonden voor "{{searchTerm}}".',
        'membersListCard.aggregateMembersToggle.label': 'Toon ook subgroepen',
        'ownershipCard.title': 'Eigenaarschap',
        'ownershipCard.aggregateRelationsToggle.label':
          'Toon ook indirect eigenaarschap',
        'userProfileCard.userNotFound': 'Gebruiker niet gevonden',
        'userProfileCard.editIconButtonTitle': 'Bewerk metadata',
        'userProfileCard.listItemTitle.email': 'E-mail',
        'userProfileCard.listItemTitle.memberOf': 'Lid van',
        'userProfileCard.moreGroupButtonTitle': 'Meer ({{number}})',
        'userProfileCard.allGroupDialog.title': 'Alle groepen van {{name}}:',
        'userProfileCard.allGroupDialog.closeButtonTitle': 'Sluit',
      },
    }),
  },
});
